<template>
	<div>
		<a-page-header style="background: #fff;" title="积分订单详情" />
		<div class="mainBox">
			<div class="searchBox" v-if="basicForm">
				<a-page-header :ghost="false">
					<a-descriptions :column="2">
						<a-descriptions-item label="订单号"><strong>{{basicForm.integralOrderNum}}</strong></a-descriptions-item>
						<a-descriptions-item label="下单时间"><strong>{{basicForm.addTime}}</strong></a-descriptions-item>
						<a-descriptions-item label="支付方式">
							<a-tag color="green">
								<a-icon type="wallet" /> 积分</a-tag>
						</a-descriptions-item>
						<a-descriptions-item label="会员信息" v-if="basicForm.userInfo">
							<a-tag color="orange" v-if="basicForm.userInfo.memberSfName">{{basicForm.userInfo.memberSfName}}</a-tag>
							<strong>
								<a-icon type="user" /> {{basicForm.userInfo.memberName}}
								<a-icon type="mobile" /> {{basicForm.userInfo.memberPhone}}</strong></a-descriptions-item>
						<a-descriptions-item label="微信信息" v-if="basicForm.wxInfo">
							<a-avatar :src="basicForm.wxInfo.headpic" size="small" /> {{basicForm.wxInfo.nickname}}
							<a-icon type="man" style="color:#597ef7 ;" v-if="basicForm.wxInfo.sex == 1" />
							<a-icon style="color:#f759ab ;" type="woman" v-if="basicForm.wxInfo.sex == 2" />
						</a-descriptions-item>
					</a-descriptions>
				</a-page-header>
			</div>
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="basicForm.goodsInfo" rowKey="id" :pagination="false" :loading="loading">
					<span slot="integralGoodsThumb" slot-scope="integralGoodsThumb">
						<a-avatar shape="square" :src="integralGoodsThumb" :size="70" />
					</span>
					<span slot="goodsDelivery" slot-scope="goodsDelivery">
						<a-tag color="green" v-if="goodsDelivery == 1">现货</a-tag>
						<a-tag color="blue" v-if="goodsDelivery == 2">隔日到</a-tag>
					</span>
					<span slot="className" slot-scope="className">
						<a-tag color="blue" v-if="className">{{className}}</a-tag>
					</span>
					<span slot="goodsPrice" slot-scope="text,goodsPrice">
							<span style="font-weight: 700;">{{goodsPrice.integralGoodsPrice}} 积分 × {{basicForm.num}}</span>
					</span>
				</a-table>
				<div style="text-align: right;padding: 10px 0;"><div style="font-size: 26px;font-weight: 700;">合计：{{basicForm.integralOrderJfUsed}} 积分</div>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '商品名称',
			dataIndex: 'integralGoodsName',
		},
		{
			title: '缩略图',
			dataIndex: 'integralGoodsThumb',
			scopedSlots: {
				customRender: 'integralGoodsThumb'
			},
		},
		{
			title: '售价',
			dataIndex: 'goodsPrice',
			scopedSlots: {
				customRender: 'goodsPrice'
			},
		},
	];

	export default {
		data() {
			return {
				columns,
				loading: false,
				basicForm: {}
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			getDetail() {
				this.loading = true
				this.$http.post('/admin/index.php/admin/Shop/integralOrderInfo', {
					id: this.id,
				}).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.basicForm = res.data.data


					}
				})
			},
		},
	}
</script>

<style scoped="">
</style>
